import React, { Component } from "react";

import { Modal } from "reactstrap";
import { config, msg } from "../../constants";
import CallApi from "../../util/CallApi";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchOrders } from "../../store/orders/ordersAction";
import { toggleDetailModal, updateDetail } from "../../store/orders/ordersAction";
import { fetchProjectAddrLabel, fetchProjectMsisdn } from "../../store/project/projectAction";
import { toggleAlert } from "../../store/alertbox/alertboxAction";
import axios from "axios";

const callApi = new CallApi();
const locale = require("react-redux-i18n").I18n;

class DetailModal extends Component {

  state = {
    normalMode: true,
    msisdnList: [],
    msisdnSelect: '',
    msisdnValiCode: '',
    msisdnValiDate: false,
    msisdnValiMsg: msg.custErrExistMsisdn,
    detailModal: this.props.modal,
    addressDelively: this.props.address_delivery ? "at006" : "at003",
    addressBill: 'at002',
    IRModal: false,
    existNumModal: false,
    provinceBillId: 0,
    districtBillId: 0,
    subDistrictBillId: 0,
    msisdnData: [],
    orderDetail: {
      msisdn_type: "new",
      msisdn: "",
      ir_flag: false,
      address_delivery: {
        address_type: this.props.address_delivery ? "at006" : "at003",
        building_name: '',
        floors: '',
        moo: '',
        houseno: '',
        room_no: '',
        soi: '',
        streetname: '',
        city: '',
        amphur: '',
        tumbon: '',
        zip: ''
      },
      address_bill: {
        address_type: "at002",
        building_name: '',
        floors: '',
        moo: '',
        houseno: '',
        room_no: '',
        soi: '',
        streetname: '',
        city: '',
        amphur: '',
        tumbon: '',
        zip: ''
      }
    },
    msisdn: '',
    ir_flag: false,
    msisdn_type: '',
    provinceDeliveryId: 0,
    districtDeliveryId: 0,
    subDistrictDeliveryId: 0,
    checkMsisdn: "",
    errors: {
      address_delivery: {
        city: "",
        amphur: "",
        tumbon: "",
        zip: ""
      },
      address_bill: {
        city: "",
        amphur: "",
        tumbon: "",
        zip: ""
      }
    }
  };

  componentDidMount = async () => {

    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});

    // if (parseInt(resp.data.code) === 200) {
    //   localStorage.setItem('sys_token', resp.data.token);
    // }

    this.props.fetchProjectAddrLabel();
  }

  // componentWillMount() {
  //   this.props.fetchProjectAddrLabel();
  // }


  componentWillReceiveProps(next) {
    if (next.order.order_detail) {
      console.log('have new order')
      const orderDetail = next.order.order_detail;
      delete orderDetail["msisdn_display"];
      delete orderDetail["address_bill_type"];
      delete orderDetail["address_delivery_type"];
      delete orderDetail["address_bill_display"];
      delete orderDetail["address_delivery_display"];

      if (orderDetail.address_delivery !== '' && orderDetail.hasOwnProperty('address_delivery')) {
        if (typeof orderDetail.address_delivery.address_type !== "undefined") {
          this.setState({ addressDelively: orderDetail.address_delivery.address_type });
        }
      }
      if (orderDetail.address_bill !== '' && orderDetail.hasOwnProperty('address_bill')) {
        if (typeof orderDetail.address_bill.address_type !== "undefined") {
          this.setState({ addressBill: orderDetail.address_bill.address_type });
        }
      }
      if (orderDetail.hasOwnProperty('address_delivery') && orderDetail.hasOwnProperty('address_bill')) {
        if (orderDetail.address_delivery.address_type !== 'at004' && orderDetail.address_bill.address_type !== 'at004') {

          this.setState({
            msisdnData: next.order.msisdn_selected || [],
            orderDetail: {
              ...orderDetail,
              address_delivery: {
                ...orderDetail.address_delivery,
                address_type: this.state.orderDetail.address_delivery.address_type,
                building_name: '',
                floors: '',
                moo: '',
                houseno: '',
                room_no: '',
                soi: '',
                streetname: '',
                city: '',
                amphur: '',
                tumbon: '',
                zip: ''
              },
              address_bill: {
                ...orderDetail.address_bill,
                address_type: this.state.orderDetail.address_bill.address_type,
                building_name: '',
                floors: '',
                moo: '',
                houseno: '',
                room_no: '',
                soi: '',
                streetname: '',
                city: '',
                amphur: '',
                tumbon: '',
                zip: ''
              }
            }
          });
        }
        else if (orderDetail.address_delivery.address_type === 'at004' && orderDetail.address_bill.address_type !== 'at004') {
          this.setState({
            orderDetail: {
              ...orderDetail,
              address_delivery: {
                ...orderDetail.address_delivery
              },
              address_bill: {
                ...orderDetail.address_bill,
                address_type: this.state.orderDetail.address_bill.address_type,
                building_name: '',
                floors: '',
                moo: '',
                houseno: '',
                room_no: '',
                soi: '',
                streetname: '',
                city: '',
                amphur: '',
                tumbon: '',
                zip: ''
              }
            }
          });
        }
        else if (orderDetail.address_delivery.address_type !== 'at004' && orderDetail.address_bill.address_type === 'at004') {
          this.setState({
            orderDetail: {
              ...orderDetail,
              address_delivery: {
                ...orderDetail.address_delivery,
                address_type: this.state.orderDetail.address_delivery.address_type,
                building_name: '',
                floors: '',
                moo: '',
                houseno: '',
                room_no: '',
                soi: '',
                streetname: '',
                city: '',
                amphur: '',
                tumbon: '',
                zip: ''
              },
              address_bill: {
                ...orderDetail.address_bill
              }
            }
          });
        }
        else {
          this.setState({ ...this.state.orderDetail, orderDetail });
        }

      }

      if (orderDetail.hasOwnProperty('address_delivery') && orderDetail.address_delivery.address_type === "at004") {
        const provinceName = orderDetail.address_delivery.city;
        const province = next.provincesData.find(province => province.name === provinceName);

        const districtName = orderDetail.address_delivery.amphur;
        const district = next.districtsData.find(district => district.name === districtName);

        const subDistrictName = orderDetail.address_delivery.tumbon;
        const subDistrict = next.subDistrictsData.find(sdistrict => sdistrict.name === subDistrictName);

        if (typeof province !== 'undefined' && typeof district !== 'undefined' && typeof subDistrict !== 'undefined') {
          this.setState({
            provinceDeliveryId: province.id,
            districtDeliveryId: district.id,
            subDistrictDeliveryId: subDistrict.id,
          });
        }
      }

      if (orderDetail.hasOwnProperty('address_bill') && orderDetail.address_bill.address_type === "at004") {
        const provinceName = orderDetail.address_bill.city;
        const province = next.provincesData.find(province => province.name === provinceName);
        const districtName = orderDetail.address_bill.amphur;
        const district = next.districtsData.find(district => district.name === districtName);
        const subDistrictName = orderDetail.address_bill.tumbon;
        const subDistrict = next.subDistrictsData.find(sdistrict => sdistrict.name === subDistrictName);
        if (typeof province !== 'undefined' && typeof district !== 'undefined' && typeof subDistrict !== 'undefined') {
          this.setState({
            provinceBillId: province.id,
            districtBillId: district.id,
            subDistrictBillId: subDistrict.id,
          });
        }
      }
    }
    if (next.project.billaddress_type_id === 'bt002') {
      this.setState({
        addressBill: 'at003',
        orderDetail: {
          ...this.state.orderDetail,
          address_bill: {
            ...this.state.orderDetail.address_bill,
            address_type: 'at003'
          }
        }
      })
    }
  }

  toggleIRBox = async (e) => {
    const { checked } = e.target;
    await this.setState({
      orderDetail: {
        ...this.state.orderDetail,
        ir_flag: checked
      }
    });
    if (checked) {
      this.setState({
        IRModal: !this.state.IRModal,
        existNumModal: false
      });
    }
  }

  closeModal = () => {
    this.setState({
      IRModal: false,
      existNumModal: false
    });
  }

  toggleExistNumber = (e) => {
    const { checked, name, value } = e.target;
    if (checked) {
      this.setState({
        existNumModal: !this.state.existNumModal,
        IRModal: false,
        orderDetail: {
          ...this.state.orderDetail,
          [name]: value
        }
      });
    }
  }

  changeAddressType = e => {
    const { value, name } = e.target;
    const addrType = e.target.getAttribute('addr_type');
    let addressDetail = { ...this.state.orderDetail[addrType], address_type: value };
    this.setState({
      [name]: value,
      orderDetail: {
        ...this.state.orderDetail,
        address_bill: {
          ...this.state.orderDetail.address_bill
        },
        address_delivery: {
          ...this.state.orderDetail.address_delivery
        },
        [addrType]: addressDetail


      }
    });
  }

  selectMsisdn = (msisdn) => {
    this.setState({
      msisdnSelect: msisdn
    })
  }

  toggle = () => {
    this.setState({
      checkMsisdn: '',
      normalMode: true,
      msisdnList: [],
      msisdnSelect: '',
    })
    this.props.toggleDetailModal({});
  };

  getDistrict = type => {
    if (type === 'delivery') {
      return this.props.districtsData.filter(district =>
        district.provinceID === this.state.provinceDeliveryId
      )
    }
    else if (type === 'bill') {
      return this.props.districtsData.filter(district =>
        district.provinceID === this.state.provinceBillId
      )
    }
  };

  getSubDistrict = type => {
    if (type === 'delivery') {
      return this.props.subDistrictsData.filter(subDistrict =>
        subDistrict.provinceID === this.state.provinceDeliveryId && subDistrict.districtID === this.state.districtDeliveryId
      )
    }
    else if (type === 'bill') {
      return this.props.subDistrictsData.filter(subDistrict =>
        subDistrict.provinceID === this.state.provinceBillId && subDistrict.districtID === this.state.districtBillId
      )
    }
  };

  getZipcode = type => {
    if (type === 'delivery') {
      return this.props.zipcodesData.filter(zipcode =>
        zipcode.provinceID === this.state.provinceDeliveryId && zipcode.districtID === this.state.districtDeliveryId && zipcode.subDistrictID === this.state.subDistrictDeliveryId
      )
    }
    else if (type === 'bill') {
      return this.props.zipcodesData.filter(zipcode =>
        zipcode.provinceID === this.state.provinceBillId && zipcode.districtID === this.state.districtBillId && zipcode.subDistrictID === this.state.subDistrictBillId
      )
    }
  };

  onProvinceChange = ({ target }) => {
    const selectedIndex = target.options.selectedIndex;
    const id = target.options[selectedIndex].getAttribute('id');
    const type = target.options[selectedIndex].getAttribute('type');
    const addrType = "address_" + type;
    const provinceType = "province" + type.charAt(0).toUpperCase() + type.slice(1) + "Id";
    this.setState({
      [provinceType]: id,
      districtId: 0,
      subDistrictId: 0,
      orderDetail: {
        ...this.state.orderDetail,
        [addrType]: {
          ...this.state.orderDetail[addrType],
          city: target.value,
          amphur: "",
          tumbon: "",
          zip: ""
        }
      }
    });
    if (target.value !== '') {
      this.setState({
        errors: {
          address_delivery: {
            ...this.state.errors.address_delivery,
          },
          address_bill: {
            ...this.state.errors.address_bill,
          },
          [addrType]: {
            ...this.state.errors[addrType],
            city: ''
          }
        }
      });
    }
  };

  onDistrictChange = ({ target }) => {
    const selectedIndex = target.options.selectedIndex;
    const id = target.options[selectedIndex].getAttribute('id');
    const type = target.options[selectedIndex].getAttribute('type');
    const addrType = "address_" + type;
    const districtType = "district" + type.charAt(0).toUpperCase() + type.slice(1) + "Id";
    this.setState({
      [districtType]: id,
      subDistrictId: 0,
      orderDetail: {
        ...this.state.orderDetail,
        [addrType]: {
          ...this.state.orderDetail[addrType],
          amphur: target.value,
          tumbon: "",
          zip: ""
        }
      }
    });
    if (target.value !== '') {
      this.setState({
        errors: {
          address_delivery: {
            ...this.state.errors.address_delivery,
          },
          address_bill: {
            ...this.state.errors.address_bill,
          },
          [addrType]: {
            ...this.state.errors[addrType],
            amphur: ''
          }
        }
      });
    }
  }

  onSubDistrictChange = ({ target }) => {
    const selectedIndex = target.options.selectedIndex;
    const id = target.options[selectedIndex].getAttribute('id');
    const type = target.options[selectedIndex].getAttribute('type');
    const addrType = "address_" + type;
    const subDistrictType = "subDistrict" + type.charAt(0).toUpperCase() + type.slice(1) + "Id";
    this.setState({
      [subDistrictType]: id,
      orderDetail: {
        ...this.state.orderDetail,
        [addrType]: {
          ...this.state.orderDetail[addrType],
          tumbon: target.value
        }
      }
    });

    if (target.value !== '') {
      this.setState({
        errors: {
          address_delivery: {
            ...this.state.errors.address_delivery,
          },
          address_bill: {
            ...this.state.errors.address_bill,
          },
          [addrType]: {
            ...this.state.errors[addrType],
            tumbon: ''
          }
        }
      });
    }
  }

  handleMChange = e => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    var orderDetail = {}
    orderDetail[name] = value;
    this.setState({
      orderDetail
    });
  }

  handleOrderChange = e => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      checkMsisdn: '',
      msisdnValiCode: '',
      msisdnValiDate: false,
      orderDetail: {
        ...this.state.orderDetail,
        msisdn: '',
        [name]: value
      }
    });
  }

  handleInputAddrChange = e => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const typeAddr = target.getAttribute('typeaddr');
    const address = 'address_' + typeAddr;
    let orderDetail = { ...this.state.orderDetail };
    orderDetail[address][name] = value;
    this.setState({
      orderDetail
    });

    if (name === "zip" && target.value !== '') {
      this.setState({
        errors: {
          address_delivery: {
            ...this.state.errors.address_delivery,
          },
          address_bill: {
            ...this.state.errors.address_bill,
          },
          [address]: {
            ...this.state.errors[address],
            zip: ''
          }
        }
      });
    }
  }

  chkStatusDisable = () => {
    if (this.props.order.order_status === 'N' || this.props.order.order_status === 'W') {
      if (this.props.project.order_status === 'A') {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  checkedBoxIrFlag = () => {
    return this.props.order.ir_flag === 1 ? true : false;
  }



  onVerifyMsisdn = () => {
    const msisdn = this.state.orderDetail.msisdn;
    const mock = false;
    const pass = true;
    if (msisdn === '') {
      return false
    }
    if (mock) {
      if (pass) {
        this.setState({ checkMsisdn: 'pass' });
      }
      else {
        this.setState({ checkMsisdn: 'fail' });
      }
    }
    else {
      callApi.postSecurity("/verifynumber", {
        project_id: this.props.project.project_id,
        msisdn: msisdn,
        order_id: this.props.order.order_id
      })
        .then(data => {
          this.setState({
            msisdnValiDate: true
          });
          if (data.code === "0000") {
            this.setState({
              msisdnValiCode: data.code,
              checkMsisdn: 'pass'
            });
          }
          else {
            this.setState({
              msisdnValiCode: data.code,
              checkMsisdn: 'fail',
              msisdnValiMsg: data.text ? data.text : this.state.msisdnValiMsg
            });
          }
        })
        .catch(error => {
          alert(msg.errMessage);
        });
    }
  }

  validateOrderDetail = () => {
    let passValidate = true;
    let addrType = [];
    const state = this.state;


    if (this.state.addressDelively === "at004") {
      addrType.push("address_delivery");
    }
    if (this.state.addressBill === "at004") {
      addrType.push("address_bill");
    }
    let errors = {
      msisdnEmpty: "",
      address_delivery: {
        city: "",
        amphur: "",
        tumbon: "",
        zip: ""
      },
      address_bill: {
        city: "",
        amphur: "",
        tumbon: "",
        zip: ""
      }
    }
    addrType.forEach(function (v) {
      if (state.orderDetail[v].city === "" || typeof state.orderDetail[v].city == "undefined") {
        passValidate = false;
        errors[v].city = locale.t("validateRequire");
      }
      if (state.orderDetail[v].amphur === "" || typeof state.orderDetail[v].amphur == "undefined") {
        passValidate = false;
        errors[v].amphur = locale.t("validateRequire");
      }
      if (state.orderDetail[v].tumbon === "" || typeof state.orderDetail[v].tumbon == "undefined") {
        passValidate = false;
        errors[v].tumbon = locale.t("validateRequire");

      }
      if (state.orderDetail[v].zip === "" || typeof state.orderDetail[v].zip == "undefined") {
        passValidate = false;
        errors[v].zip = locale.t("validateRequire");
      }
    });

    if (state.orderDetail.msisdn_type === "existing" && (state.orderDetail.msisdn === "" || state.orderDetail.msisdn === undefined || state.orderDetail.msisdn === null)) {
      passValidate = false;
      errors.msisdnEmpty = locale.t("validateRequire");
    }
    if (state.orderDetail.msisdn_type === "existing" && state.checkMsisdn === '') {
      passValidate = false;
      state.checkMsisdn = 'check'
    }
    if (state.orderDetail.msisdn_type === "existing" && state.checkMsisdn === 'fail') {
      passValidate = true;
    }
    this.setState({
      ...this.state,
      errors
    })
    return passValidate;
  }

  clickChooseMsisdn = () => {
    this.loadMsisdn()
    // console.log('choose Msisdn')
    this.setState({
      normalMode: false
    })
  }

  loadMsisdn = () => {
    const thisComp = this
    callApi.postSecurity("/project/msisdn/" + this.props.project.project_id, {
      x: 1
    })
      .then(data => {
        console.log('/project/msisdn/data', data)
        thisComp.setState({

          msisdnList: data,
        })
      }).catch(error => {
        console.log(error)
      });
  }

  blackToNormal = () => {
    // console.log('choose Msisdn')
    this.setState({
      normalMode: true
    })
  }

  sentMarkMsisdn = () => {
    const thisComp = this
    console.log('sentMarkMsisdn log prop ', thisComp.props)
    // console.log('sentMarkMsisdn log state ',thisComp.state)
    const msisdnSelect = this.state.msisdnSelect
    const sentParam = {
      project_id: this.props.project.project_id,
      msisdn: msisdnSelect,
      order_id: this.props.order.order_id
    }

    callApi.postSecurity("/order/add/msisdn/", sentParam)
      .then(data => {
        console.log('/order/add/msisdn/', data)

        this.props.fetchOrders({
          project_id: this.props.project.project_id,
          customer_id: this.props.customerID
        });

        thisComp.setState({
          msisdnData: [{ msisdn: msisdnSelect }],
          msisdnSelect: '',
          normalMode: true
        })

      }).catch(error => {
        console.log(error)
      });
  }

  handleChangeInput = event => {
    const { value, maxLength } = event.target;
    const message = value.slice(0, maxLength);
    this.setState({
      checkMsisdn: '',
      orderDetail: {
        ...this.state.orderDetail,
        msisdn: message
      }
    });
  };

  handleSubmit = () => {

    if (this.validateOrderDetail()) {
      const $state = this.state;
      const addrTypeDelivery = this.props.addressLabel.find(function (val) {
        return val.address_type_id === $state.orderDetail.address_delivery.address_type;
      });
      var addrTypeBill = {};
      if ($state.addressBill === 'at003') {
        addrTypeBill = this.props.projectAddrData
      } else {
        addrTypeBill = this.props.addressLabel.find(function (val) {
          return val.address_type_id === $state.orderDetail.address_bill.address_type;
        });
      }
      const emptyAddress = {
        building_name: '',
        floors: '',
        moo: '',
        houseno: '',
        room_no: '',
        soi: '',
        streetname: '',
        city: '',
        amphur: '',
        tumbon: '',
        zip: ''
      }
      let address_delivery = { ...this.state.orderDetail.address_delivery, address_name: addrTypeDelivery.address_type_id };
      let address_bill = { ...this.state.orderDetail.address_bill, address_name: addrTypeBill.address_type_id }
      if (this.state.orderDetail.address_delivery.address_type !== 'at004') {
        address_delivery = { ...address_delivery, ...emptyAddress }
      }
      if (this.state.orderDetail.address_bill.address_type !== 'at004') {
        address_bill = { ...address_bill, ...emptyAddress }
      }

      this.setState({
        orderDetail: {
          ...this.state.orderDetail,
          project_id: this.props.order.project_id,
          customer_id: this.props.customerID,
          product_id: this.props.order.product_id,
          address_bill: address_bill,
          address_delivery: address_delivery,
          msisdn_type: this.state.orderDetail.msisdn_type === null ? 'new' : this.state.orderDetail.msisdn_type,
          ir_flag: this.state.orderDetail.ir_flag !== undefined ?
            this.state.orderDetail.ir_flag
            :
            this.props.order.ir_flag ?
              this.props.order.ir_flag === 1 ? true : false
              : false,
          msisdnValiCode: this.state.msisdnValiCode,
          msisdnValiDate: this.state.msisdnValiDate
        }
      }, async () => {
        const orderData = { ...this.props.order, order_detail: this.state.orderDetail };
        await this.props.updateDetail(orderData);
        this.props.toggleDetailModal({});
        window.location.reload();
      });
    } else {
      this.props.toggleAlert(msg.custRequireFiled);
    }
  }

  render() {
    const addrType = this.props.addressLabel;
    let addrTypeBill;
    if (this.props.projectData.billaddress_type_id === "bt002") {
      addrTypeBill = addrType.find(function (addr) {
        return addr.address_type_id === 'at003';
      });
      addrTypeBill = addrTypeBill ? [addrTypeBill] : [];
    }
    else {
      addrTypeBill = addrType;
    }
    return (
      <>
        <Modal size="lg"
          isOpen={this.props.isDetailModalOpen}
          toggle={this.toggle}
          className={this.props.className}
          style={{ maxWidth: "1000px" }}
        >
          {(!this.state.normalMode) ? <div className="modal-content" >
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">{'กรุณาเลือกหมายเลขโทรศัพท์ที่ท่านต้องการ'}</h5>
              <button type="button" className="close" onClick={this.toggle} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <div style={{ clear: 'both', fontWeight: 'bold', float: 'left', color: 'red', fontSize: '14px', padding: '5px' }}>{'***ในขั้นตอนการเลือกหมายเลขใหม่  แจ้งกรณีต้องการเปลี่ยนหมายเลข จะต้องลบ Order และจองสินค้าใหม่***'}</div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {this.state.msisdnList.map(m => (parseInt(m.cn) !== 0) ? null : <div className="btn btn-cf" onClick={() => {
                    this.selectMsisdn(m.msisdn)
                  }} style={{ cursor: 'pointer', padding: '5px', textAlign: 'center', margin: '5px', backgroundColor: (parseInt(this.state.msisdnSelect) === parseInt(m.msisdn)) ? '#E91D25' : '#666666' }}>{m.msisdn}</div>)}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-cc" onClick={this.blackToNormal} data-dismiss="modal">{locale.t("กลับ")}</button>
              <button type="button" className="btn btn-cf" onClick={this.sentMarkMsisdn} disabled={(this.state.msisdnSelect === '')}>
                {'เลือก'}
              </button>
            </div>
          </div> : <div className="modal-content" >
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">{locale.t("detail")}</h5>
              <button type="button" className="close" onClick={this.toggle} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div><div className="modal-body">
              <div className="row">
                <div className="col-sm-12 col-md-7">

                  <section className="modal-section">
                    <label className="label--checkbox">

                      {locale.t("addrDelivery")}
                    </label>
                    <div className="boxsection-select">
                      {/* <div className="select select-md">
                        <select
                          className="form-control form-control-md s1"
                          value={this.state.addressDelively}
                          onChange={this.changeAddressType}
                          addr_type="address_delivery"
                          name="addressDelively"
                          disabled={this.chkStatusDisable()}
                        >
                          {addrType.map((addr) =>
                            <option key={addr.address_type_id} value={addr.address_type_id}>{addr.address_type_desc}</option>
                          )}

                        </select>
                      </div> */}

                      {this.state.addressDelively === 'at002' && (
                        <ThaiIDAddr profile={this.props} />
                      )}
                      {this.state.addressDelively === 'at003' && (
                        <OfficeAddr address={this.props.projectAddrData} profile={this.props.customerData} />
                      )}
                      {this.state.addressDelively === 'at004' && (
                        <CustomAddr provinces={this.props.provincesData} getDistrict={this.getDistrict} getSubDistrict={this.getSubDistrict} getZipcode={this.getZipcode} onProvinceChange={this.onProvinceChange} onDistrictChange={this.onDistrictChange} onSubDistrictChange={this.onSubDistrictChange} addressDetail={this.state.orderDetail.address_delivery} handleInputAddrChange={this.handleInputAddrChange} type="delivery" errors={this.state.errors} />
                      )}
                      {this.state.addressDelively === 'at005' && (
                        <ThaiIDAddr profile={this.props} address_type={'at005'} />
                      )}
                      {this.state.addressDelively === 'at006' && (
                        <ThaiIDAddr profile={this.props} address_type={'at006'} />
                      )}


                    </div>
                  </section>
                  <section className="modal-section">
                    <label className="label--checkbox">

                      {locale.t("addrBill")}
                    </label>
                    <div className="boxsection-select">
                      {addrTypeBill.length !== 0 &&
                        <div className="select select-md">
                          <select
                            className="form-control form-control-md s2"
                            value={this.state.addressBill}
                            onChange={this.changeAddressType}
                            addr_type="address_bill"
                            name="addressBill"
                            disabled={this.chkStatusDisable()}
                          >
                            {addrTypeBill.map((addr) =>
                              <option key={addr.address_type_id} value={addr.address_type_id}>{addr.address_type_desc}</option>
                            )}

                          </select>
                        </div>
                      }
                      {this.state.addressBill === 'at002' && (
                        <ThaiIDAddr profile={this.props} />
                      )}
                      {this.state.addressBill === 'at003' && (
                        <OfficeAddr address={this.props.projectAddrData} profile={this.props.customerData} />
                      )}
                      {this.state.addressBill === 'at004' && (
                        <CustomAddr provinces={this.props.provincesData} getDistrict={this.getDistrict} getSubDistrict={this.getSubDistrict} getZipcode={this.getZipcode} onProvinceChange={this.onProvinceChange} onDistrictChange={this.onDistrictChange} onSubDistrictChange={this.onSubDistrictChange} addressDetail={this.state.orderDetail.address_bill} handleInputAddrChange={this.handleInputAddrChange} type="bill" errors={this.state.errors} />
                      )}
                      {this.state.addressBill === 'at005' && (
                        <ThaiIDAddr profile={this.props} address_type={'at005'} />
                      )}
                      {this.state.addressBill === 'at006' && (
                        <ThaiIDAddr profile={this.props} address_type={'at006'} />
                      )}
                    </div>
                  </section>
                </div>
                <div className="col-sm-12 col-md-5">
                  <h4 className="modal-ttl">{locale.t("telNumberService")} </h4>
                  <section className="modal-section">
                    <div className="modal-tal-box">
                      {(this.props.projectData.number_type_id === 'nt001' || this.props.projectData.number_type_id === 'nt004') &&
                        <>
                          <label className="label--radio" nbt={this.props.projectData.number_type_id}>
                            <input
                              type="radio"
                              className="radio"
                              name="msisdn_type"
                              value="new"
                              defaultChecked={this.state.orderDetail.msisdn_type === 'new' || this.state.orderDetail.msisdn_type === null}
                              onClick={this.handleOrderChange}
                              disabled={this.chkStatusDisable()}
                              style={{ marginRight: '5px' }}
                            />
                            {locale.t("newNumber")}
                          </label>
                          {(this.props.projectData.number_type_id === 'nt004') ? ((this.state.msisdnData.length > 0) ? (<div style={{ padding: '5px', textAlign: 'left', fontWeight: 'bold', marginLeft: '13px', marginTop: '-20px' }}>{this.state.msisdnData[0].msisdn}</div>) :
                            <button className="btn btn-cf" style={{ marginLeft: '5px' }} type="button" onClick={this.clickChooseMsisdn}>{'เลือกเบอร์'}</button>)
                            : null}
                        </>
                      }
                      {this.props.projectData.number_type_id === 'nt002' &&
                        <label className="label--radio" nbt={this.props.projectData.number_type_id}>
                          <input
                            type="radio"
                            className="radio"
                            name="msisdn_type"
                            value="existing"
                            defaultChecked={this.state.orderDetail.msisdn_type === 'existing'}
                            onClick={this.toggleExistNumber}
                            disabled={this.chkStatusDisable()}
                            style={{ marginRight: '5px' }}
                          />
                          {locale.t("existNumber")}
                        </label>
                      }

                      {(this.props.projectData.number_type_id === 'nt003' || this.props.projectData.number_type_id === 'nt005') &&
                        <>
                          <label className="label--radio" nbt={this.props.projectData.number_type_id}>
                            <input
                              type="radio"
                              className="radio"
                              name="msisdn_type"
                              value="new"
                              defaultChecked={this.state.orderDetail.msisdn_type === 'new' || this.state.orderDetail.msisdn_type === null}
                              onClick={this.handleOrderChange}
                              disabled={this.chkStatusDisable()}
                              style={{ marginRight: '5px' }}
                            />
                            {locale.t("newNumber")}
                          </label>
                          {(this.props.projectData.number_type_id === 'nt005') ? ((this.state.msisdnData.length > 0) ? (<div style={{ padding: '5px', textAlign: 'left', fontWeight: 'bold', marginLeft: '13px', marginTop: '-20px' }}>{this.state.msisdnData[0].msisdn}</div>) :
                            <button className="btn btn-cf" style={{ marginLeft: '5px' }} type="button" onClick={this.clickChooseMsisdn}>{'เลือกเบอร์'}</button>)
                            : null}
                          <label className="label--radio" nbt={this.props.projectData.number_type_id}>
                            <input
                              type="radio"
                              className="radio"
                              name="msisdn_type"
                              value="existing"
                              defaultChecked={this.state.orderDetail.msisdn_type === 'existing'}
                              onClick={this.toggleExistNumber}
                              disabled={this.chkStatusDisable()}
                              style={{ marginRight: '5px' }}
                            />
                            {locale.t("existNumber")}
                          </label>
                        </>
                      }

                    </div>
                    {(this.props.projectData.number_type_id === 'nt002' || this.props.projectData.number_type_id === 'nt003' || this.props.projectData.number_type_id === 'nt005') &&
                      <div className="boxsection-select" nbt={this.props.projectData.number_type_id}>
                        <div className="address-box">
                          <div className="form-group">
                            <label htmlFor="" >{locale.t("verifyNumber")}</label>
                            <input
                              type="text"
                              className="form-control"
                              name="msisdn"
                              onChange={this.handleChangeInput}
                              value={this.state.orderDetail.msisdn}
                              id=""
                              placeholder=""
                              maxLength="10"
                              disabled={this.state.orderDetail.msisdn_type !== 'existing' ? true : false}
                            />
                            {(this.state.checkMsisdn === "pass" &&
                              <span className="tel-pass"><i className="la la-check-circle"></i> {msg.custSuccessExistMsisdn}</span>
                            )}
                            {(this.state.checkMsisdn === "fail" &&
                              <span className="mt-2 text-secondary"> {this.state.msisdnValiMsg} </span>
                            )}
                            {(this.state.checkMsisdn === "empty" &&
                              <span className="mt-2 text-secondary"> {locale.t("validateRequire")}</span>
                            )}
                            {(this.state.checkMsisdn === "check" &&
                              <span className="mt-2 text-secondary"> {locale.t("validateCheck")}</span>
                            )}

                            <button
                              type="button"
                              onClick={this.onVerifyMsisdn}
                              className="btn btn-primary btn-sm btn-check-tel"
                              disabled={this.chkStatusDisable()}
                            >
                              ตรวจสอบ
                            </button>
                          </div>
                        </div>
                      </div>
                    }


                  </section>
                  {this.props.projectData.flag_ir === 1 ? (
                    <div className="box-ir">
                      <label className="label--checkbox">
                        <input
                          type="checkbox"
                          className="checkbox"
                          name="ir_flag"
                          defaultChecked={this.checkedBoxIrFlag()}
                          onClick={this.toggleIRBox}
                          disabled={this.chkStatusDisable()}
                        />
                        {locale.t("IR")}<br />
                        {locale.t("IDD")}
                      </label>
                    </div>
                  ) : ('')}

                </div>
              </div>
              <Modal isOpen={this.state.IRModal} toggle={this.toggleIRBox} >

                <div className="modal-body">
                  <p>{this.props.projectData.txt_ir_msg}</p>
                </div>
                <div className="modal-footer flex-center">
                  <button
                    type="button"
                    className="btn btn-alert-secondary"
                    data-dismiss="modal"
                    onClick={this.closeModal}
                  >
                    {locale.t("ok")}
                  </button>

                </div>
              </Modal>
              <Modal isOpen={this.state.existNumModal} toggle={this.toggleExistNumber} >

                <div className="modal-body">
                  <p>{this.props.projectData.txt_mnp_msg}</p>
                </div>
                <div className="modal-footer flex-center">
                  <button
                    type="button"
                    className="btn btn-alert-secondary"
                    data-dismiss="modal"
                    onClick={this.closeModal}
                  >
                    {locale.t("ok")}
                  </button>

                </div>
              </Modal>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-cc" onClick={this.toggle} data-dismiss="modal">{locale.t("cancel")}</button>
              <button type="button" className="btn btn-cf" onClick={this.handleSubmit} disabled={this.chkStatusDisable()}>
                {locale.t("save")}
              </button>
            </div>
          </div>}
        </Modal>

      </>
    );
  }
}

const ThaiIDAddr = (props) => {

  const { title, firstname, lastname } = props.profile.user;
  const { address_name, building_name, houseno, moo, floors, soi, streetname, tumbon, amphur, city, zip } =
    props.address_type === 'at005' ?
      props.profile.address_company : props.address_type === 'at006' ? props.profile.address_delivery : props.profile.user.address;
  return (
    <div className="box2 address-box">
      <p>{title} {firstname} {lastname}</p>
      <p>{address_name}</p>
      <p>เลขที่ {houseno ? houseno : '-'} หมู่บ้าน/อาคาร {building_name ? building_name : '-'}
        {" "}ชั้น {floors ? floors : '-'}
        {" "}หมู่ {moo ? moo : '-'} ตรอก/ซอย {soi ? soi : '-'} ถนน {streetname ? streetname : '-'}
        {" "}ตำบล/แขวง {tumbon ? tumbon : '-'} อำเภอ/เขต {amphur ? amphur : '-'}
        {" "}จังหวัด {city ? city : '-'} รหัสไปรษณีย์ {zip ? zip : '-'}
      </p>
    </div>
  );
}

const OfficeAddr = (props) => {
  const { title, firstname, lastname } = props.profile;
  const { address_name, building_name, houseno, moo, floors, soi, streetname, tumbon, amphur, city, zip } = props.address;
  return (
    <div className="box2 address-box">
      <p>{title} {firstname} {lastname}</p>
      <p>{address_name}</p>
      <p>เลขที่ {houseno ? houseno : '-'} หมู่บ้าน/อาคาร {building_name ? building_name : '-'}
        {" "}ชั้น {floors ? floors : '-'}
        {" "}หมู่ {moo ? moo : '-'} ตรอก/ซอย {soi ? soi : '-'} ถนน {streetname ? streetname : '-'}
        {" "}ตำบล/แขวง {tumbon ? tumbon : '-'} อำเภอ/เขต {amphur ? amphur : '-'}
        {" "}จังหวัด {city ? city : '-'} รหัสไปรษณีย์ {zip ? zip : '-'}
      </p>
    </div>
  );
}

const CustomAddr = (props) => {
  const { provinces, getDistrict, getSubDistrict, getZipcode, onProvinceChange, onDistrictChange, onSubDistrictChange, addressDetail, handleInputAddrChange, type, errors } = props;
  const err_type = 'address_' + type

  const provinceItems = provinces.map((province) =>
    <option key={province.id} id={province.id} type={type} value={province.name}>{province.name}</option>
  );
  provinceItems.unshift(
    <option key="p" type={type} value="">-- เลือกจังหวัด --</option>
  );

  const districtItems = getDistrict(type).map((district) =>
    <option key={district.id} id={district.id} type={type} value={district.name}>{district.name}</option>
  );
  districtItems.unshift(
    <option key="d" type={type} value="">-- เลือกอำเภอ/เขต --</option>
  );

  const subDistrictItems = getSubDistrict(type).map((subDistrict) =>
    <option key={subDistrict.id} id={subDistrict.id} type={type} value={subDistrict.name}>{subDistrict.name}</option>
  );
  subDistrictItems.unshift(
    <option key="s" type={type} value="">-- เลือกตำบล/แขวง --</option>
  );

  const zipcodeItems = getZipcode(type).map((zipcode) =>
    <option key={zipcode.id} id={zipcode.id} value={zipcode.code}>{zipcode.code}</option>
  );
  zipcodeItems.unshift(
    <option key="z" type={type} value="">-- เลือกรหัสไปรษณีย์ --</option>
  );

  return (
    <div className="box1_other boxother" style={{ display: "block" }}>
      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">เลขที่</label>
        <div className="col-md-12 col-lg-9">
          <input type="text" name="houseno" onChange={handleInputAddrChange} className="form-control form-control-sm form-edit" id="" typeaddr={type} defaultValue={addressDetail.houseno} maxLength="10" />
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">หมู่บ้าน/อาคาร</label>
        <div className="col-md-12 col-lg-9">
          <input type="text" name="building_name" className="form-control form-control-sm form-edit" onChange={handleInputAddrChange} id="" typeaddr={type} defaultValue={addressDetail.building_name} />
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">ชั้น</label>
        <div className="col-md-12 col-lg-9">
          <input type="text" name="floors" className="form-control form-control-sm form-edit" onChange={handleInputAddrChange} id="" typeaddr={type} defaultValue={addressDetail.floors} maxLength="10" />
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">หมู่</label>
        <div className="col-md-12 col-lg-9">
          <input type="text" name="moo" className="form-control form-control-sm form-edit" onChange={handleInputAddrChange} id="" typeaddr={type} defaultValue={addressDetail.moo} maxLength="10" />
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">ตรอก/ซอย</label>
        <div className="col-md-12 col-lg-9">
          <input type="text" name="soi" className="form-control form-control-sm form-edit" onChange={handleInputAddrChange} id="" typeaddr={type} defaultValue={addressDetail.soi} />
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">ถนน</label>
        <div className="col-md-12 col-lg-9">
          <input type="text" name="streetname" className="form-control form-control-sm form-edit" onChange={handleInputAddrChange} id="" typeaddr={type} defaultValue={addressDetail.streetname} />
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">จังหวัด* </label>
        <div className="col-md-12 col-lg-9">
          <div className="select">
            <select className="form-control form-control-sm" defaultValue={addressDetail.city} name="city" onChange={onProvinceChange}>
              {provinceItems}
            </select>
          </div>
          <div className="mt-2 text-danger">{errors[err_type].city}</div>
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">อำเภอ/เขต* </label>
        <div className="col-md-12 col-lg-9">
          <div className="select">
            <select className="form-control form-control-sm" defaultValue={addressDetail.amphur} name="amphur" onChange={onDistrictChange}>
              {districtItems}
            </select>
          </div>
          <div className="mt-2 text-danger">{errors[err_type].amphur}</div>
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">ตำบล/แขวง* </label>
        <div className="col-md-12 col-lg-9">
          <div className="select">
            <select className="form-control form-control-sm" defaultValue={addressDetail.tumbon} name="tumbon" onChange={onSubDistrictChange}>
              {subDistrictItems}

            </select>
          </div>
          <div className="mt-2 text-danger">{errors[err_type].tumbon}</div>
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="" className="col-md-12 col-lg-3 col-form-label">รหัสไปรษณีย์* </label>
        <div className="col-md-12 col-lg-9">
          <div className="select">
            <select className="form-control form-control-sm" typeaddr={type} defaultValue={addressDetail.zip} onChange={handleInputAddrChange} name="zip" >
              {zipcodeItems}
            </select>
          </div>
          <div className="mt-2 text-danger">{errors[err_type].zip}</div>
        </div>
      </div>
    </div>
  )
}

DetailModal.propTypes = {
  fetchOrders: PropTypes.func.isRequired,
  orders: PropTypes.array.isRequired,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  isDetailModalOpen: state.orders.isDetailModalOpen,
  toggleDetailModal: state.orders.toggleDetailModal,
  order: state.orders.order,
  addressLabel: state.project.address_label,
  address_company: state.project.address_company,
  address_delivery: state.project.address_delivery,
  project: state.project.info,
  customerID: state.login.customerID,
  user: state.customer.data,
  toggleAlert: PropTypes.func.isRequired,
  l: state.i18n.locale
});

export default connect(mapStateToProps, {
  toggleDetailModal,
  fetchProjectAddrLabel,
  fetchProjectMsisdn,
  fetchOrders,
  toggleAlert,
  updateDetail
})(DetailModal);